export const generateRecap = () => {
  console.log('boo');
};
